import { deck2Blueprint } from "@made-people/blueprint-menu/blueprint";

deck2Blueprint.main.override({
  slots: {
    wrapper: "flex gap-10 text-[var(--foreground)]",
    deckWrapper:
      "bg-[var(--background)] text-black fixed top-0 -z-10 left-0 w-full overflow-hidden",
    deckContent:
      "grid grid-cols-[3fr_1fr] px-component-spacing-xs md:px-component-spacing-md lg:px-component-spacing-md max-w-component-max-w-xl box-content mx-auto",
    deckColumns: "columns-3 pt-28 pb-10",
    topLevel: "flex gap-6 xl:gap-10 items-center",
  },
});

deck2Blueprint.menuItem.override({
  slots: {
    item: "text-body-md",
  },
});

deck2Blueprint.submenu.override({
  slots: {
    submenu: "pb-7 break-inside-avoid-column flex flex-col items-start gap-1.5",
    submenuHeading:
      "text-eyebrow-sm uppercase text-less-emphasis-1 font-medium mb-3",
    item: "text-body-md",
  },
});
